import { useEffect } from "react";
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";
import { useRouter } from 'next/navigation'
import ModalContactForm from "components/Forms/Contact/AgentContactModal";

import { modalSet } from "_slices/view";
import { getUserDetails } from "context/context";

type Props = {
  address: object,
  name: string,
  id: number,
  docType: string
}

const AgentContactForm = ({ address, name, id, docType}: Props) => {
  const reduxDispatch = useDispatch();
  const modal = useSelector((state: RootStateOrAny) => state.view.modal);
  const loggedIn = useSelector((state: RootStateOrAny) => state.auth.loggedIn);
  const userDetails = getUserDetails();
  const router = useRouter();
  // const [{ contactForm, active }, dispatch] = useResultReducer();
  // const { id,address,type,name,rep } = active;

  let property = {
    type: docType,
    id:id,
    name:name,
    address:address
  }

   let agent = modal.view ? modal.view : null;
  // let company = agent ? rep.companies[agent.repType][agent.company] : null;
  const company = null;

  const closeModal = () => {
    reduxDispatch(
      modalSet({
        visible: false,
        router
      })
    );
    reduxDispatch({ type: "contactFormReset" });
    const myBody = document.body;
    if(myBody && myBody.classList.contains('ContactForm__Body--open')) {
      myBody.classList.remove('ContactForm__Body--open')
    }
  };

  useEffect(() => {
  }, [loggedIn, userDetails]);

  return (
    <ModalContactForm
      user={userDetails}
      resultId={id}
      type={docType}
      property={property}
      id="contactUsAgent"
      agent={agent}
      company={company}
      form={[

      ]}
      onSubmit={(e) => {
        e.preventDefault();
      }}
      modal={{
        id: "contactUsModalAgent",
        isOpen: modal.type === "contactAgentProperty" && modal.visible,
        label: `Send a message`,
        closeModal: closeModal,
        onClick: (e) => {
          e.stopPropagation();
        },
      }}
    />
  );
};

export default AgentContactForm;
